<template>
  <div class="AppReviewReport my-4">
    <!-- Render iframe only when URL is available -->
    <iframe
      v-if="iframeUrl"
      :src="iframeUrl"
      style="width: 100%; height: 100vh; border: none"
      sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
    ></iframe>
  </div>
</template>

<script lang="ts">
import { Component } from "vue-property-decorator";
import ModelVue from "@/components/ModelVue";
import { InsightApi } from "@/remote-api-point";

@Component({})
export default class MetabaseDashboardForIneligible extends ModelVue {
  iframeUrl: string = "";
  dashboardId = this.$route.params.dashboardId;

  mounted() {
    this.generateMetabseIneligibleUrl();
  }

  async generateMetabseIneligibleUrl() {
    try {
      const query = this.$route.query || {};

      const response = await InsightApi.get(
        "/api/metabase/get-metabase-url",
        {
          params: {
            dashboardId: this.dashboardId,
            params: JSON.stringify({ ...query }),
          },
        }
      );

      this.iframeUrl = response.data;
      console.log("Metabase iframe URL:", response.data);
    } catch (error) {
      console.error("Failed to load Metabase dashboard:", error);
    }
  }
}
</script>

<style scoped>
.AppReviewReport {
  width: 100%;
}
</style>
